<template>
  <b-button size="sm" title="Mudar a versão da tela" :href="'/' + rota">
    <i class="fa fa-shopping-bag"></i>{{ " " + label }}
  </b-button>
  <!--:to="{ name: rota }"-->
</template>
<script>
export default {
  props: ["label", "rota"],
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/TrocarDeProjeto.vue